<template>
  <v-dialog v-model="dialogProxy" max-width="500" persistent>
    <v-card class="dialog-card" elevation="0">
      <v-card-title
        class="dialog-title d-flex justify-space-between align-center"
      >
        <div class="d-flex align-center">
          <v-icon class="mr-2" color="#F4811F">
            mdi-shape-outline
          </v-icon>
          <span class="dialog-title-text">{{ title }}</span>
        </div>

        <v-btn icon small @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-card-text class="dialog-body">
        <v-container class="pa-0">
          <v-row>
            <v-col cols="12">
              <div class="label-text mb-1">ชื่อหมวดหมู่ <span class="red--text">*</span></div>
              <v-text-field
                v-model="localItem.name"
                placeholder="ระบุชื่อหมวดหมู่"
                outlined
                dense
                hide-details
                class="rounded-lg mb-4"
              ></v-text-field>

              <div class="label-text mb-1">สถานะ</div>
              <v-switch
                v-model="localItem.isActive"
                :label="localItem.isActive ? 'เปิดใช้งาน' : 'ปิดใช้งาน'"
                color="success"
                inset
                dense
                hide-details
                class="mt-0"
              ></v-switch>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn
          color="#F3F4F6"
          class="cancel-btn mr-2"
          elevation="0"
          @click="close"
        >
          <span style="color: #374151">ยกเลิก</span>
        </v-btn>
        <v-btn
          color="#F4811F"
          class="confirm-btn"
          elevation="0"
          @click="save"
        >
          <span style="color: white">บันทึก</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CategoryDialog",
  props: {
    value: { type: Boolean, default: false },
    item: { type: Object, default: () => ({}) },
    mode: { type: String, default: "create" }
  },
  data() {
    return {
      localItem: {
        name: "",
        isActive: true, // Default true
      },
    };
  },
  computed: {
    dialogProxy: {
      get() { return this.value; },
      set(v) { this.$emit("input", v); }
    },
    title() {
      return this.mode === "create" ? "สร้างหมวดหมู่ใหม่" : "แก้ไขหมวดหมู่";
    }
  },
  watch: {
    value(val) {
      if (val) {
        if (this.mode === 'edit' && this.item) {
            this.localItem = { 
                ...this.item,
                isActive: this.item.isActive !== undefined ? this.item.isActive : true
            };
        } else {
            this.localItem = { name: "", isActive: true };
        }
      }
    }
  },
  methods: {
    close() {
      this.dialogProxy = false;
    },
    save() {
       this.$emit("save", { ...this.localItem });
    }
  }
};
</script>

<style scoped>
.dialog-card {
  border-radius: 16px !important;
  box-shadow: none !important;
}
::v-deep(.v-dialog) {
  box-shadow: none !important;
}
.dialog-title {
  padding: 20px 24px 16px !important;
}
.dialog-body {
  padding: 20px 24px 24px !important;
}
.dialog-title-text {
  font-size: 18px;
  font-weight: 600;
  color: #1f2a39;
}
.label-text {
  font-size: 14px;
  font-weight: 400;
  color: #6b717f;
}
.cancel-btn, .confirm-btn {
    border-radius: 8px !important;
    text-transform: none !important;
    height: 40px !important;
    font-weight: 600;
    font-size: 16px;
    width: 100px;
}
</style>
